import React from 'react';
import { View } from 'react-native';
import { useTheme, StatusBadge, Icons } from '@hmsexp/component-library';

const AlertsBadge = ({ alertStatus, alertType }) => {
  const { palette } = useTheme();

  const formatText = value => {
    if (!value) return '';

    if (value === 'Safety Alert') {
      return 'Safety Alert';
    } else if (value === 'Item Not Working Alert') {
      return 'Item Not Working Alert';
    } else if (value === 'NEW') {
      return 'New';
    } else if (value === 'IN PROGRESS') {
      return 'In Progress';
    } else if (value === 'OVERDUE') {
      return 'Overdue';
    } else if (value === 'CLOSED') {
      return 'Closed';
    }
  };

  const backgroundColorMap = {
    'NEW': palette.cautionBackgroundLow,
    'IN PROGRESS': palette.hyperlinkBackgroundLow,
    'OVERDUE': palette.negativeBackgroundLow,
    'CLOSED': palette.primaryBackgroundLow
  };

  const renderIcon = () => {
    return (
      <>
        <Icons.BellIcon size='M' />
      </>
    );
  };
  return (
    <View>
      <StatusBadge
        style={{
          textStyle: {
            color: palette.primaryContentHigh
          },
          contentWrapper: {
            marginHorizontal: '10px'
          },
          titleContainer: {
            marginBottom: 0
          },
          subtitleContainer: {
            marginTop: 0
          },
          wrapper: {
            display: 'flex',
            alignItems: 'center',
            height: '50px',
            padding: '10px',
            backgroundColor: backgroundColorMap[alertStatus] || palette.cautionBackgroundLow
          }
        }}
        subtitle={formatText(alertType)}
        title={formatText(alertStatus)}
        renderIcon={renderIcon}
      />
    </View>
  );
};

export default AlertsBadge;
